import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import * as baseActions from 'actions/base';
import * as driverActions from 'actions/drivers';
import * as userActions from 'actions/users';
import * as vehicleActions from 'actions/vehicles';
import * as dedicatedContractActions from 'actions/dedicated-contracts';

import { vehiclesIncreasingBySize, contactsIncreasingAlphabetical } from 'utils/sort';

import { getCurrentCarrier } from 'redux/modules/carrier-section/selectors';

import { getAllRoutePairs } from 'reselects';

import { updateCarrier } from 'actions/carriers';

import ContractModal from 'components/ContractModal';

const actionCreators = {
  ...driverActions,
  ...userActions,
  ...baseActions,
  ...vehicleActions,
  ...dedicatedContractActions,
  updateCarrier,
};

class CarrierContractEdit extends Component {
  render() {
    const {
      carrier,
      drivers,
      onCloseModal,
      createDedicatedContract,
      dedicatedContracts,
      updateExceptionsDedicatedContract,
      finishDedicatedContract,
      match,
      vehicles,
    } = this.props;

    const sortedDrivers = drivers.sort(contactsIncreasingAlphabetical);
    const sortedVehicles = vehicles.sort(vehiclesIncreasingBySize).filter((v) => !!v);
    const selectedContract = parseInt(match.params.contract_id, 10);
    const currentContract = dedicatedContracts.filter(
      (contract) => contract.id === selectedContract
    )[0];

    return carrier ? (
      <Fragment>
        {!currentContract ? (
          <ContractModal
            show={true}
            carrier={carrier}
            vehicles={sortedVehicles}
            drivers={sortedDrivers}
            onClose={onCloseModal}
            onSave={(dedicatedContract) => {
              return createDedicatedContract(dedicatedContract);
            }}
            onSaveSuccesfully={onCloseModal}
          />
        ) : (
          <ContractModal
            show={true}
            contract={currentContract}
            carrier={carrier}
            vehicles={vehicles}
            drivers={sortedDrivers}
            onClose={onCloseModal}
            onSave={(dedicatedContract) => {
              return createDedicatedContract(dedicatedContract);
            }}
            onUpdateExceptionsClick={(exceptions) => {
              return updateExceptionsDedicatedContract(currentContract, exceptions);
            }}
            onFinish={(end_date) => {
              return finishDedicatedContract(currentContract, end_date);
            }}
            onSaveSuccesfully={onCloseModal}
          />
        )}
      </Fragment>
    ) : null;
  }
}

CarrierContractEdit.propTypes = {
  carrier: PropTypes.object,
  drivers: PropTypes.array,
  dedicatedContracts: PropTypes.array,
  onCloseModal: PropTypes.func,
  createDedicatedContract: PropTypes.func,
  updateExceptionsDedicatedContract: PropTypes.func,
  finishDedicatedContract: PropTypes.func,
  vehicles: PropTypes.array,
  match: PropTypes.object,
};

export default connect((state, { match }) => {
  const currentCarrier = getCurrentCarrier(state);

  return {
    carrier: currentCarrier,
    drivers: (currentCarrier || {}).drivers,
    vehicles: (currentCarrier || {}).vehicles,
    allRoutes: getAllRoutePairs(state),
    dedicatedContracts: state.dedicatedContracts.results || [],
  };
}, actionCreators)(CarrierContractEdit);
